import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Router } from '@angular/router'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { ButtonComponent } from '../button/button.component'
import { LinkComponent } from '../link/link.component'
import { GalleryGridComponent } from '../gallery-grid/gallery-grid.component'
import { ApiService } from '../../services/api.service'
import { Gallery } from '../../interfaces/api/Gallery'
import { GalleryImage } from '../../interfaces/api/GalleryImage'

@Component({
    selector: 'app-galleries',
    templateUrl: './galleries.component.html',
    styleUrl: './galleries.component.scss',
    standalone: true,
    imports: [
      CommonModule,
      ButtonComponent,
      GalleryGridComponent,
      TranslateModule
    ]
})
export class GalleriesComponent {
    private _query!: string
    private debounceTimer: any

    @Input()
    set query(nuevoValor: string) {
        this._query = nuevoValor

        clearTimeout(this.debounceTimer) // limpia el timeout anterior

        this.debounceTimer = setTimeout(() => {
            this.api.myGalleries__list(this._query).subscribe(galleries => {
                this.galleries = galleries;
            })
        }, 300) // espera 300ms antes de hacer la petición
    }

    get query(): string {
        return this._query
    }

    categories: string[]

    @Output() galleryImageChange = new EventEmitter<GalleryImage>()
    @Output() validCombination = new EventEmitter<boolean>()

    galleries: Gallery[]

    constructor(private router: Router, private api: ApiService) {
        this.categories = ['Kitchens', 'Bathrooms', 'Living', 'Outside', 'Other']
    }

    ngOnInit() {
        this.categories = ['Kitchens', 'Bathrooms', 'Living', 'Outside', 'Other']
    }

    onNavigate() {
        this.router.navigate(['/my-gallery'])
    }
}
